<template>
  <div class="cover" :style="{minHeight: clientHeight}">
    <nav-header
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showOrNot="p_showOrNot"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal">
    </nav-header>
    <img class="banner banner-phone" src="../../assets/enter_banner_iphone_in.png" alt="检验网新冠检测产品海外订单采购流程">
    <img class="banner banner-pc" src="../../assets/enter_banner_pc_in.png" alt="检验网新冠检测产品海外订单采购流程">
    <div class="cover_in">
      <div class="wrap">
        <div class="explain">
          <div class="explain_title">
            说明：
          </div>
          <div class="explain_content">
            <p>在全球疫情爆发期间，我司收到了大量来自外贸用户关于新冠检测产品的订单和咨询需求，为了让您更加便捷、高效的获得新冠核酸检测相关产品和服务，现提供线上统一信息登记入口，请按照下方提示进行信息登记，我司会有专人为您提供服务。</p>
          </div>
          <div class="explain_title">
            步骤：
          </div>
        </div>
        <div class="process">
          <div class="step">
            <img src="../../assets/enter_step.png" alt="检验网新冠检测产品海外订单采购流程icon">
            <p>1</p>
          </div>
          <div class="process_content">
            <div class="process_title">
              信息登记入口
            </div>
            <div class="process_intro">
              填写国外订单采购申请表并上传资质证明，等待工作人员与您联系，开通下单权限
            </div>
            <div class="process_btn" @click="toApply">
              <p>采购申请 > </p>
            </div>
          </div>
        </div>
        <div class="process">
          <div class="step">
            <img src="../../assets/enter_step.png" alt="">
            <p>2</p>
          </div>
          <div class="process_content">
            <div class="process_title">
              下单
            </div>
            <div class="process_intro">
              采购申请提交后，工作人员会与您联系，待审核通过后为您开通下单权限，可自行选择线上下单
            </div>
            <div class="process_btn" @click="toOrder">
              <p>开始下单 > </p>
            </div>
          </div>
        </div>
        <div class="explain">
          <div class="explain_title">
            疫情相关产品：
          </div>
          <div class="explain_pro">
            <ul>
              <li v-for="item in itemList" :key="item.id" @click="todetection(item.id,item.remark)">
                <img :src="item.img" alt="检验网新冠检测产品海外订单采购流程">
                <p>{{item.itemName}}</p>
              </li>
            </ul>
          </div>
          <div class="more_btn">
            <p @click="toOrder">查看更多 > </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import NavHeader from "@/components/Header.vue";
  import {getCookie, removeHTMLTag} from "../../util/util"

  export default {
    name: "NovelCoronavirusEnter",
    data() {
      return {
        clientHeight: 0,
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showOrNot: 'not',
        providerId: 19,
        itemList: []
      }
    },
    computed: {

    },
    components: {
      NavHeader
    },
    mounted() {
      this.$store.commit("updateProviderId", this.providerId)
      axios.get("/jys/item/category/name", {
        params: {
          name: '海外疫情产品',
          providerId: this.providerId
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.itemList = res.data.itemList
        }
      })
      setTimeout(() => {
        this.clientHeight = document.documentElement.clientHeight + 'px'
      }, 100)
    },
    methods: {
      p_showLoginModal () {
        this.p_loginModalFlag = true;
      },

      p_closeLoginModal () {
        this.p_loginModalFlag = false;
      },
      toApply() {
        window.scroll(0, 0)
        this.$router.push({path: "/NovelCoronavirusEnterApply"})
      },
      toOrder() {
        window.scroll(0, 0)
        this.$router.push({
          path: "/company/index",
          query: {id: this.providerId}
        })
      },
      todetection(id, remark) {
        this.$router.push({path: "/detection", query: {id: id, remark: remark}})
      }
    }
  }
</script>

<style scoped>
  .cover{
    width: 100%;
    float: left;
    background-color: #0468c9;
  }
  .cover_in{
    width: 100%;
    margin: 0 auto;
  }
  .cover .banner{
    width: 100%;
    float: left;
  }
  .wrap{
    float: left;
    margin: 40px 30px;
    border-radius: 10px;
    background-color: #ffffff;
  }
  .explain{
    float: left;
    padding: 30px;
    box-sizing: border-box;
    color: #131313;
    font-size: 13px;
  }
  .explain_title,
  .explain_content{
    width: 100%;
    float: left;
  }
  .explain_title{
    font-weight: bolder;
    padding-left: 10px;
    border-left: 3px solid #0468c9;
  }
  .explain_content{
    padding: 10px 0 25px 13px;
  }
  .explain_pro,
  .explain_pro ul{
    width: 100%;
    float: left;
  }
  .explain_pro li{
    width: 100%;
    float: left;
    padding: 20px;
    cursor: pointer;
  }
  .explain_pro li img{
    width: 100%;
    margin-bottom: 15px;
  }
  .process{
    float: left;
    margin: 0 30px;
    padding: 20px 0;
    box-sizing: border-box;
    color: #888888;
    font-size: 13px;
    position: relative;
    border-left: 3px solid #0468c9;
  }
  .step{
    position: absolute;
    top: 15px;
    left: -15px;
  }
  .process_content{
    float: left;
    margin: 0 0 0 35px;
  }
  .step img{
    width: 34px;
    height: 25px;
  }
  .step p{
    position: absolute;
    top: 3px;
    left: 10px;
    color: #ffffff;
  }
  .process_title{
    color: #0468c9;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  .process_intro{
    font-size: 12px;
    margin-bottom: 10px;
  }
  .process_btn{
    width: 100px;
    float: left;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    background-color: #0468c9;
    cursor: pointer;
  }
  .template{
    margin-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    color: #108EE9;
    text-decoration: underline;
    cursor: pointer;
  }
  .process_code {
    width: 80px;
    height: 80px;
    text-align: center;
    font-size: 12px;
  }
  .process_code img{
    width: 100%;
  }
  .process:last-child{
    margin-bottom: 50px;
  }
  .banner-phone{
    display: block;
  }
  .banner-pc{
    display: none;
  }
  .more_btn{
    width: 100%;
    float: left;
    margin: 20px 0;
  }
  .more_btn p{
    width: 260px;
    margin: 0 auto;
    line-height: 35px;
    text-align: center;
    color: #ffffff;
    background-color: #0468c9;
    border-color: #0468c9;
  }
  @media only screen and (min-width: 600px) {
    .banner-phone{
      display: none;
    }
    .banner-pc{
      display: block;
    }
    .cover_in{
      width: 45%;
    }
    .step{
      top: 35px;
    }
    .process{
      padding: 40px 0;
    }
    .explain{
      padding-bottom: 30px;
    }
    .explain_content{
      padding-bottom: 30px;
    }
    .process_code{
      width: 100px;
      height: 100px;
    }
    .explain_pro li{
      width: 25%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/activities/novel-coronavirus-enter.vue